import type { PricingModel } from '@weft/types';
import { PRICING_MODELS } from '@weft/types';

export const USAGE_PRICING_MODELS: PricingModel[] = [PRICING_MODELS.Tiers, PRICING_MODELS.PerUnit, PRICING_MODELS.TieredSubscription];

export const FIXED_PRICING_MODELS: PricingModel[] = [
  PRICING_MODELS.FixedOneTime,
  PRICING_MODELS.FixedPerUnit,
  PRICING_MODELS.Subscription,
  PRICING_MODELS.CommercialTerms,
  PRICING_MODELS.Commission,
  PRICING_MODELS.Installments,
  PRICING_MODELS.Refund,
];